var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checked",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.018,
    height: 19.018,
    viewBox: "0 0 19.018 19.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M9.509,0a9.509,9.509,0,1,0,9.509,9.509A9.52,9.52,0,0,0,9.509,0Zm5.315,7.007-6.077,6.03a.935.935,0,0,1-1.311.024L4.218,10.129a.967.967,0,0,1-.071-1.335.943.943,0,0,1,1.335-.048l2.55,2.336,5.434-5.434a.961.961,0,1,1,1.358,1.358Z",
    fill: "#4397d2"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.fa879964f80b7f6c3579d9eafba0ce6e.svg";
export { ForwardRef as ReactComponent };